// extracted by mini-css-extract-plugin
export default {"iconCard":"Cards_iconCard__fTu4v","title":"Cards_title__Zk9N+"};